import { Header } from "components/DesignSystem/Header/Header";
import { usePageTitle } from "hooks/usePageTitle";
import { useContext, useEffect, useState } from "react";
import authContext from "../../jwt_context&axios/authContext";
import "../../static/styles/components/profileSetting.css";
import { ProfilePicUpdate } from "./profilePicUpdate";
import { ProfileUpdate } from "./profileUpdate";
import Tab from "components/DesignSystem/Tab/Tab";
import { Route, useLocation, useRouteMatch, Switch } from "react-router-dom";
import { DashboardLayout } from "components/DashboardLayout";
import { SlackIntegration } from "components/SlackIntegration";
import { Divider } from "components/design/Divider";
import { Switch as SwitchComponent } from "components/DesignSystem/Switch/Switch";
import { BackendError } from "types/utils/error";
import { useToast } from "hooks/useToast";
import { useUpdateWhatsappConsentMutation } from "store/apis/profile";
import { ManagePasskeys } from "components/webauthn/ManagePasskeys";

export const Settings = () => {
  usePageTitle("Profile Settings");
  const { pathname, hash } = useLocation();
  const { url, path } = useRouteMatch();
  const { authtoken, updateUser } = useContext(authContext);
  const { alertToast, successToast } = useToast();

  const [updateWhatsappConsent] = useUpdateWhatsappConsentMutation();
  const [isChecked, setIsChecked] = useState<boolean>(
    authtoken.whatsapp_consent ?? false
  );

  useEffect(() => {
    if (hash !== "#passkeys") return;
    document
      .getElementById("passkeys")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [hash]);

  const onChange = async () => {
    const newValue = !isChecked;
    const toastMessage =
      newValue === true
        ? "Whatsapp notifications enabled"
        : "Whatsapp notifications disabled";
    setIsChecked(newValue);
    try {
      await updateWhatsappConsent({
        payload: { whatsapp_consent: newValue },
      }).unwrap();

      updateUser({ data: { whatsapp_consent: newValue } });
      successToast({ message: toastMessage });
    } catch (error) {
      setIsChecked(isChecked);
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <DashboardLayout>
      <div className="t-w-[680px] t-max-w-full t-mx-auto">
        <div className="t-flex t-flex-col t-gap-8 t-mt-3">
          <ProfilePicUpdate />
          <ProfileUpdate user={authtoken} updateUser={updateUser} />
        </div>
        <div>
          <Divider classNames="t-my-7" />
          {authtoken.is_slack_added && (
            <>
              <div>
                <div className="t-mb-1.5 t-text-body-sm t-text-text-30">
                  Connections
                </div>
                <div className="t-mb-6 t-w-full">
                  {!authtoken.is_any_service_user && (
                    <SlackIntegration
                      reverse={true}
                      hideOnceAdded={false}
                      floating={false}
                      isChat={false}
                    />
                  )}
                </div>
              </div>
            </>
          )}
          <div className="t-flex t-flex-col t-gap-1.5">
            <div className="t-text-body-sm t-text-text-30">Whatsapp</div>
            <div className="t-flex t-items-center t-justify-between t-gap-4">
              <div className="t-shrink-0 t-flex t-justify-center t-items-center">
                <SwitchComponent
                  checked={isChecked}
                  name="whatsappConsent"
                  onCheckedChange={onChange}
                />
              </div>
              <label
                htmlFor="whatsappConsent"
                className="t-cursor-pointer t-w-full t-flex t-flex-col t-gap-0.5"
              >
                <div className="t-text-body-sm t-text-text-60">
                  Enable WhatsApp notifications
                </div>
                <div className="t-text-body-sm-lite t-text-neutral-50">
                  You'll hear from us on WhatsApp only when something actually
                  needs your attention. No marketing messages!
                </div>
              </label>
            </div>
          </div>
          <Divider classNames="t-my-7 sm:t-hidden" />
          <div id="passkeys" className="t-pb-10 sm:t-hidden">
            <ManagePasskeys />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
